import CaseBadge from './CaseBadge'

// Link-kind → item renderer. Parity with insights_contract.LINK_KINDS (the backend
// whitelist that gates authoring). Each entry renders one linkable item as its own
// interactive element, which owns what selecting it does — `case` renders a
// CaseBadge, whose click opens the case-evidence modal in place (no navigation, so
// the insight modal underneath is never unmounted). A kind missing here falls back
// to a plain, non-clickable pill rather than breaking the page (see BlockRenderer).
export const LINK_KINDS = {
  case: (item, key) => <CaseBadge key={key} caseId={item.label} caseUid={item.ref} />,
}
